export default __webpack_public_path__ + "static/media/phone-player-app-small.70f3a5dc.png";